/// <amd-module name="Build/Shared/Components/DetailsSection/index" />
export * from "./DetailsSection";
export { IDetailsChevronProps, IDetailsSectionProps } from "./DetailsSection.types";
